module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Alternative Unit",
      "modal": true,
      "visible": _vm.displayDialog,
      "closable": false,
      "contentStyle": {
        'overflow': 'scroll'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [(this.isPurchaseSales === 'purchase') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Unit From",
      "field": "unitFrom"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "From Qty",
      "field": "unitFromValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit To",
      "field": "unitTo",
      "filterField": "unitTo"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "To Qty",
      "field": "unitToValue",
      "filterField": "unitToValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.isPurchaseSales === 'sales') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Unit From",
      "field": "unitFrom"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "From Qty",
      "field": "unitFromValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit To",
      "field": "unitTo",
      "filterField": "unitTo"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "To Qty",
      "field": "unitToValue",
      "filterField": "unitToValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.isPurchaseSales === 'purchase') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "editMode": "cell"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_vm._v("\n            Formula Table\n          ")]
      },
      proxy: true
    }], null, false, 2407204242)
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit From",
      "field": "unitFrom"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "From Qty",
      "field": "unitFromValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Unit To",
      "field": "unitTo",
      "filterField": "unitTo"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "To Qty",
      "field": "unitToValue",
      "filterField": "unitToValue"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 2289769392)
  })], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2866eac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/commonDialogs/UnitConversionDetail.vue
// module id = 2381
// module chunks = 0